import { render, staticRenderFns } from "./ProductTypeNavbar.vue?vue&type=template&id=b8712b10&scoped=true&"
import script from "./ProductTypeNavbar.vue?vue&type=script&lang=js&"
export * from "./ProductTypeNavbar.vue?vue&type=script&lang=js&"
import style0 from "./ProductTypeNavbar.vue?vue&type=style&index=0&id=b8712b10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8712b10",
  null
  
)

export default component.exports